import { Injectable, OnDestroy } from '@angular/core';
import { combineLatest, Subject } from 'rxjs';
import { ScriptService } from '../../services/script.service';
import { BaseSiteService, LanguageService, PageContext, RoutingService, WindowRef } from '@spartacus/core';
import { takeUntil } from 'rxjs/operators';
import { EnvironmentService } from '../../services/environment.service';
import { CurrentProductService } from '@spartacus/storefront';

interface IAdvizeInterface {
  config: IAdvizeInterfaceConfig;
}

interface IAdvizeInterfaceConfig {
  sid: number;
  lang: string;
}

interface IAdvizeCustomData {
  product_id: string;
  page_type: string;
}

declare global {
  interface Window {
    iAdvizeInterface?: IAdvizeInterface;
    idzCustomData?: IAdvizeCustomData;
  }
}

@Injectable({
  providedIn: 'root',
})
export class IAdvizeDataFactory implements OnDestroy {
  destroyed = new Subject<void>();
  pageTypeMapping = {
    ProductPage: 'product_page',
    CategoryPage: 'product_list',
  };

  constructor(
    private scriptService: ScriptService,
    private baseSiteService: BaseSiteService,
    private routingService: RoutingService,
    private environmentService: EnvironmentService,
    private winRef: WindowRef,
    private currentProductService: CurrentProductService,
    private languageService: LanguageService
  ) {}

  build(): void {
    if (this.winRef.isBrowser()) {
      combineLatest([
        this.baseSiteService.getActive(),
        this.languageService.getActive(),
      ])
        .pipe(takeUntil(this.destroyed))
        .subscribe(([baseSite, language]) => {
          window.iAdvizeInterface = {
            config: {
              sid: this.environmentService.getCurrentEnvironment().iAdvize[baseSite],
              lang: language,
            },
          };

          this.scriptService.loadScript('iAdvize').then((data) => {
            console.log(data);
          });
        });

      combineLatest([
        this.routingService.getPageContext(),
        this.currentProductService.getProduct(),
      ])
        .pipe(takeUntil(this.destroyed))
        .subscribe(([page, product]) => {
          window.idzCustomData = {
            product_id: product?.ean ?? '',
            page_type: this.getPageTypeFromPage(page),
          };
        });
    }
  }

  getPageTypeFromPage(page: PageContext) {
    if (page.type) {
      if (this.pageTypeMapping[page.type]) {
        return this.pageTypeMapping[page.type];
      }
    }

    return 'other';
  }

  ngOnDestroy(): void {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
